/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import receiveConnectionPaymentTypes from './receive-connection-payment-types';
import * as actions from 'state/action-types';

export default (paymentTypeId = null, connectionPaymentTypes) => (dispatch) => {
    const isNew = !paymentTypeId;
    if (isNew) {
        return cecSdk
            .connectionPaymentTypes()
            .add(connectionPaymentTypes)
            .then((connectionPaymentTypes) => {
                dispatch(receiveConnectionPaymentTypes([connectionPaymentTypes]));
                dispatch({ type: actions.SAVE_CONNECTION_PAYMENT_TYPES_SUCCESS, payload: { connectionPaymentTypes, isNew } });
            });
    }

    return cecSdk
        .connectionPaymentTypes(paymentTypeId)
        .update(connectionPaymentTypes)
        .then((connectionPaymentTypes) => {
            dispatch(receiveConnectionPaymentTypes([connectionPaymentTypes]));
            dispatch({ type: actions.SAVE_CONNECTION_PAYMENT_TYPES_SUCCESS, payload: { connectionPaymentTypes } });
        });
};